import { Controller } from "@hotwired/stimulus"
import Chartkick from "chartkick";

// Connects to data-controller="chart-with-form"
export default class extends Controller {

  static targets = [
    "form",
  ];
  declare formTarget: HTMLFormElement;

  static values = {
    chartId: String,
    buttonText: String,
  }
  declare chartIdValue: string;
  declare buttonTextValue: string;

  connect() {
    let form = this.formTarget;
    form.addEventListener("submit", async event => {
      event.preventDefault();
      const url = new URL(form.action);
      const formData = new FormData(form);
      for (let [attr, value] of formData.entries()) {
        url.searchParams.append(attr, value.toString())
      }
      const data = await fetch(url, { headers: { "Accept": "application/json" } });
      const jason = await data.json();
      const chartKey = `${this.chartIdValue}_chart`;
      const chart = (Chartkick.charts as Record<string, any>)[chartKey];

      chart.updateData(jason);
      setTimeout(() => {
        const submitButton = form.querySelector<HTMLButtonElement>("button[type=\"submit\"]");
        submitButton.disabled = false;
        submitButton.textContent = this.buttonTextValue;
      }, 250);
    })
  }
}
